/**
 * Labels / visibility helpers for study-material PDFs on `lesson_attachments` (P3.8-03).
 * Storage is unchanged — this is UX copy/badge logic only.
 */
export type StudyMaterialCountBadge = "one" | "many";

export function studyMaterialCountBadge(count: number): StudyMaterialCountBadge | null {
  if (!Number.isFinite(count) || count <= 0) return null;
  return count === 1 ? "one" : "many";
}

export function shouldShowStudyMaterials(attachmentCount: number): boolean {
  return studyMaterialCountBadge(attachmentCount) !== null;
}
